import { render, staticRenderFns } from "./sdproduct4.vue?vue&type=template&id=fc2f0af6&scoped=true"
import script from "./sdproduct4.vue?vue&type=script&lang=js"
export * from "./sdproduct4.vue?vue&type=script&lang=js"
import style0 from "./sdproduct4.vue?vue&type=style&index=0&id=fc2f0af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2f0af6",
  null
  
)

export default component.exports